<template>
  <div class="row">
    <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <h4>Exigence {{$route.params.requirement_num}} - {{requirement.requirement_master_name}}
              <i style="color: #0088cc;" class="fas fa-question-circle" @click="showHelp=!showHelp"></i>
            </h4>
            <transition name="bounce">
              <div v-if="showHelp" class="alert alert-info" role="alert">
                <button type="button" class="close" aria-label="Close" @click="showHelp=false">
                  <span aria-hidden="true">&times;</span>
                </button>
                <template v-for="(helpItem, key) in requirement.help">
                  <div style="font-weight: bold" v-text="helpItem.title" :key="'a'+key"></div>
                  <div v-html="helpItem.text" :key="'b'+key"></div>
                </template>
              </div>
            </transition>

          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

            <div class="za-card">
              <div class="box-title"><span>Extrait du rapport {{requirement.period}}</span></div>
              <span class="za-label">Statut :</span>&nbsp;&nbsp;<em class="fas fa-square-full" :style="requirementStatusColor"></em>&nbsp;
              <span class="za-readonly-field" v-text="requirement.requirement_status"></span>

              <div class="za-label">Description du produit livrable</div>
              <div class="za-readonly-field" v-if="isDescriptionEmpty"><em class="text-muted">Aucune description fournie</em></div>
              <div v-else v-html="requirement.deliverable_description"></div>

              <div class="za-label">Pièces justificatives</div>
              <div class="za-readonly-field" v-if="wp_documents.length==0"><em class="text-muted">Aucun document fourni</em></div>
              <p class="za-document" v-for="document in wp_documents" :key="document.document_id">
                <a target="_blank" :href="urlForDocument(serviceprovider.workplan_id,document.document)">
                  <DocumentIcon :url="urlForDocument(serviceprovider.workplan_id,document.document)" />{{document.title}}
                </a>
              </p>
            </div>

            <div class="za-label">Interprétation du produit livrable</div>
            <div class="za_editbox" v-show="readmode_interpretation" v-on:click="editmode('interpretation')">
              <em v-if="!requirement.interpretation" class="text-muted">Entrer une interprétation...</em>
              <div v-html="requirement.interpretation"></div>
            </div>
            <span v-show="!readmode_interpretation">
              <trumbowyg :config="$trumbowygConfig" style="height:100px" class="form-control" v-model="interpretation"></trumbowyg>
              <div style="margin-top:5px">
                <button type="button" class="btn btn-primary btn-sm" v-on:click="save()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                <button type="button" class="btn btn-link btn-sm" v-on:click="cancelmode('interpretation')">Annuler</button>
              </div>
            </span>
            
            <ListDocuments :parent-id="$route.params.requirement_num" parent-type="requirement" :service-provider-id="$route.params.service_provider_id"></ListDocuments>

            <div class="za-label">Appréciation
              <a class="za-label-action" v-on:click="editmode('status')" ><i class="fas fa-plus fa-spacer" aria-hidden="true"></i>Ajouter</a>
            </div>
            <div class="row za-add" v-show="!readmode_status">
              <div class="col-sm-5">
                <div class="form-group">
                  <label class="control-label">Statut * </label>
                  <select v-model="status" class="form-control">
                    <option value="" selected>Choisir</option>
                    <option v-for="option in status_option" :value="option.status_id" :key="option.status_id">
                      {{ option.status_name}}
                    </option>
                  </select>
                  <label class="error" v-if="errors.status">{{ errors.status }}</label>
                </div>
              </div>
              <div class="col-sm-12" style="padding-top:10px">
                <trumbowyg :config="$trumbowygConfig" class="form-control" v-model="description" placeholder="Entrer l'explication..."></trumbowyg>
              </div>

              <div class="col-sm-12" style="padding-top:10px">
                <div style="margin-top:5px">
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="save_ticket()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                  <button type="button" class="btn btn-link btn-sm" v-on:click="readmode('status')">Annuler</button>
                </div>
              </div>
            </div>
            <div class="row" style='margin-top:10px'>
              <div class="col-sm-12">
                <div v-for="(ticket, key) in tickets" :key="ticket.ticket_id">
                  <div class="app_row" v-if="key==0" @click="$router.push({ name: 'billet', params: { ticket_id: ticket.ticket_id }})" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                    {{ticket.effective_at}} - {{ticket.created_by}} - <span class="badge" :style="firstAppreciationColor" >{{ticket.status}}</span>
                    <template v-if="ticket.description_text !== ''"> - {{ ticket.description_text }}</template>
                  </div>
                  <div class="app_row" v-else @click="$router.push({ name: 'billet', params: { ticket_id: ticket.ticket_id }})">
                    <span class="text-muted">{{ticket.effective_at}} - {{ticket.created_by}} - {{ticket.status}}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr style="color:#d0d0d0;width:100%;height:0;border:0.5px solid">
            <ListComment :parent_id="requirement_id" parent_class="requirement"></ListComment>

          </div>
        </div>
        <div class="row" style='margin-top:25px'>
          <div class="col-sm-12">
            <button class="btn btn-default" style='margin-right:5px' v-on:click="back" >Retour</button>
            <button class="btn btn-default" style='margin-right:5px' v-on:click="previous" v-show="(previous_next.previous!=0)">&lt; Précédent</button>
            <button class="btn btn-default" v-on:click="next" v-show="(previous_next.next!=0)">Suivant &gt;</button>
          </div>
        </div>
      </div>
    </div>
</template>

<style>
.app_row:hover {
  background-color: #e0e0e0;
  cursor: pointer;
}

.za-add {
  margin-top: 10px;
  margin-bottom: 20px;
  /* border-left: 2px solid  #e0e0e0; */
}

.box-title {
  margin-top:-11px;
  /* margin-bottom: -11px; */
  font-size: 85%;
}

.box-title span {
    background-color: white;
    padding: 0 5px;
    color: #a0a0a0;
}

.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

.trumbowyg-box, .trumbowyg-editor {
	min-height: 100px !important;
}

.za-document {
  margin: 0;
}

</style>

<script>
import DocumentIcon from '@/components/DocumentIcon.vue'
import ListComment from '@/components/ListComment.vue'
import ListDocuments from '@/components/ListDocuments.vue'

import axios from 'axios';
import {requirementStatusColor} from '@/assets/za_libs/colors.js';

export default {
  props: ['oziweb_url'],
  data: function() {return {
    showHelp: false,
    show_confirm:false,
    requirement_id:'',
    serviceprovider:{},
    requirement: {},
    previous_next:{},
    wp_documents: [],
    tickets:[],
    status:'',
    description: '',
    interpretation:'',
    status_option: {},
    readmode_interpretation:true,
    readmode_status:true,
    errors:{status:'',name:'',description:''},
    showedit:true,
  }},
  name: 'ServiceProviderRequirementDetail',

  components: {
    DocumentIcon,
    ListComment,
    ListDocuments
  },
  computed: {
    isDescriptionEmpty() {
      var cleanContent = this.requirement.deliverable_description ?
      this.requirement.deliverable_description.replace(/(<([^>]+)>)/ig,"").trim() : "";
      return cleanContent=="";
    },
    requirementStatusColor() {
      return requirementStatusColor(this.requirement.requirement_status_id);
    },
    firstAppreciationColor() {
      switch(this.tickets[0].ticket_status_key) {
        case 'conforme': return "background-color: #18B358;";
        case 'non_conforme': return "background-color: #F99A91;";
        case 'non_applicable': return "background-color: #AB4FD2;";
        case 'revue_preliminaire': return "background-color: #399ADB;";
        default: return "";
      }
    }
  },
  methods: {
    urlForDocument(workplan_id,filename) {
      return this.oziweb_url+"/upload/workplans/"+workplan_id+"/"+filename;
    },

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_requirements_detail.php',
          { params: {service_provider_id: this.$route.params.service_provider_id,requirement_num: this.$route.params.requirement_num}})
        .then(response => {
          this.$checkApiErrors(response.data);
          this.serviceprovider = response.data.serviceprovider;
          this.requirement = response.data.requirement;
          this.requirement_id = response.data.requirement.requirement_id;
          this.status_option = response.data.ticket_status;
          this.tickets = response.data.tickets;
          this.wp_documents = response.data.wp_documents;
          this.previous_next = response.data.previous_next;
        })
    },

    back: function()
    {
      this.$router.push({ name: 'exigences', params: {service_provider_id:this.$route.params.service_provider_id} });
    },

    previous: function()
    {
      this.$router.push({ name: 'exigenceDetail', params: {service_provider_id:this.$route.params.service_provider_id,requirement_num:this.previous_next.previous } });
      this.refresh();
    },

    next: function()
    {
      this.$router.push({ name: 'exigenceDetail', params: {service_provider_id:this.$route.params.service_provider_id,requirement_num:this.previous_next.next } });
      this.refresh();
    },

    editmode: function(field)
    {
      this.interpretation = this.requirement.interpretation;
      eval('this.readmode_'+field+'=false');
    },
    readmode: function(field)
    {
      eval('this.readmode_'+field+'=true');
      if(field=="status") {
        this.status='';
        this.description='';
      }
    },
    cancelmode: function(field)
    {
      this.interpretation = this.requirement.interpretation;
      this.readmode(field);
    },

    save: function()
    {
      let data = {
        requirement_id:this.requirement_id,
        interpretation:this.interpretation
      }

      axios
        .post(this.$root.$data.server_base + '/api/service_provider_requirements_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
        .then(() => (this.readmode_interpretation=true,this.refresh()))
    },
    save_ticket: function()
    {
      var empty_field = false;

      if(this.status == '')
      {
        this.errors.status = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.status = '';

      if(!empty_field)
      {
        let data = {
          ticket_type_key: 'requirement_appreciation',
            ticket_status:this.status,
            title:"Appréciation d'exigence "+this.$route.params.requirement_num,
            service_provider_id:this.$route.params.service_provider_id,
            requirement_id:this.requirement_id,
            description: this.description
        }
        
        axios
          .post(this.$root.$data.server_base + '/api/ticket_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(() => {
            this.readmode_status=true;
            this.status='';
            this.description='';
            this.refresh();
          })
      }
    },

  },
  mounted () {
    this.refresh();
  }
}
</script>
